import React from 'react';
import Header from '../Header/Header';

const About = () => {
    return (
        <div>
            <Header></Header>
            <div className='container bg-warning bg-opacity-25 p-5 rounded mt-3 border border-3 border-black'>
                <h1>We share knowledge with the world</h1>
                <h3>___Changing learning for the better___</h3>
                <br />
                <h4>Whether you want to learn or to share what you know, you’ve come to the right place. As a global destination for online learning, we connect people through knowledge.</h4>
                <ul>
                    <li>GuriLearning Branch</li>
                    <li>E-Learning Branch</li>
                    <li>Edu-co Branch</li>
                    <li>Earth Dox Branch</li>
                    <li>Int. Padma Branch</li>
                    <li>Udemy Branch</li>
                </ul>
                <h5>
                    All Branches are located in different place in the world. Above all the branches are main. and they have controlled more than 500 branches among the world.SO there are many more interesting courses in our community.SO IF you will have enrolled our community then you have some task..Firstly I have to tell you more about our interesting courses then  I talked about task.
                </h5>
                <h5>1.C++</h5>
                <h5>2.Javascript</h5>
                <h5>3.Aircraft</h5>
                <h5>4.Influencer</h5>
                <h5>5.Freelancing</h5>
                <p>There are more facilities to buy many courses from here.Beacause it is the most popular platfrom in the world without any doubt.
                Beacause of positive rating are 95% more than 1 billion.
                </p>
                <h5>So if you are a true and hard learner then you can purchase any courses because of your dedication level is on anotherlevel...Thank You.</h5>
                

            

                

            </div>
        </div>
    );
};

export default About;